import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// Every claim is grounded in EAKC-MVP:
//   src/app/api/mcp/route.ts · src/lib/mcp/{auth,tools,tools-read,tools-write}.ts
//   src/app/api/mcp/tools/invoke-agent.ts · supabase/migrations/020_mcp_api_keys.sql + 021_mcp_expansion.sql

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 4.4, caption: "My AI IDE just answered from my own knowledge base — citations and all. No browser tab." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.3, holdSec: 5.5, caption: "A RAG knowledge base is usually a web app: open a tab, type, copy the answer back to your editor." },
  { scene: "problem", fromSec: 6, holdSec: 5.5, caption: "I wanted it inside the IDE. So I built an MCP server — one weekend, the original three tools." },
];

export const INTUITION: ScriptLine[] = [
  { scene: "intuition", fromSec: 0.3, holdSec: 5, caption: "MCP is a USB port for AI: one standard, and any client speaks it." },
  { scene: "intuition", fromSec: 5.5, holdSec: 4, caption: "Implement one server, and Claude Desktop, Cursor, or Windsurf can all connect." },
];

export const SHAPE: ScriptLine[] = [
  { scene: "shape", fromSec: 0.3, holdSec: 6, caption: "The whole server is one Next.js route: POST /api/mcp. JSON-RPC 2.0 over HTTP. Stateless." },
  { scene: "shape", fromSec: 6.5, holdSec: 6.5, caption: "Initialize, then tools/list, then tools/call. Protocol version 2024-11-05." },
];

export const AUTH: ScriptLine[] = [
  { scene: "auth", fromSec: 0.3, holdSec: 6, caption: "Auth is an API key, not a session — IDE clients have no cookies. X-API-Key header." },
  { scene: "auth", fromSec: 6.5, holdSec: 6.5, caption: "SHA-256 the key, look up the hash, get a tenant_id. The raw key is never stored." },
];

export const TOOLS: ScriptLine[] = [
  { scene: "tools", fromSec: 0.3, holdSec: 6, caption: "It started with three read tools: query_eakc, list_sources, get_document." },
  { scene: "tools", fromSec: 6.5, holdSec: 6, caption: "get_document has dual tenant isolation — chunk AND parent source must match your tenant." },
  { scene: "tools", fromSec: 12.5, holdSec: 5, caption: "Today it exposes fifteen, including a write tool gated behind a can_write flag." },
];

export const GOTCHAS: ScriptLine[] = [
  { scene: "gotchas", fromSec: 0.3, holdSec: 6, caption: "Three gotchas the docs don't tell you. One: notifications/initialized must return 200, not 204." },
  { scene: "gotchas", fromSec: 6.5, holdSec: 6, caption: "Two: tool failures use isError:true — not JSON-RPC error codes, which some clients drop." },
  { scene: "gotchas", fromSec: 12.5, holdSec: 5, caption: "Three: send rate-limit headers on every response, so clients can back off." },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.3, holdSec: 6, caption: "The payoff: ask your IDE how the sync engine works — it answers with real file paths and snippets." },
  { scene: "payoff", fromSec: 6.5, holdSec: 5.5, caption: "Because it's MCP-standard, any new IDE that speaks MCP connects with zero server changes." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.3, holdSec: 5.5, caption: "One endpoint. API-key auth. Tenant-scoped tools. The knowledge base now lives where you code." },
  { scene: "outro", fromSec: 6, holdSec: 5, caption: "Next: one sync pipeline that ingests GitHub, Jira, Confluence and Slack." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
